module.exports = __webpack_public_path__ + "static/media/cb_2x.6b6edeb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/tiny/cb_2x.png
// module id = 1548
// module chunks = 27